import { Alert, Button, IconButton, Snackbar, Stack, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { VerificationSaveCommand } from "../../../../../services/verifyService/commands";
import { useSaveVerificationMutation } from "../../../../../services/verifyService/verify-api";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { useParams } from "react-router";
import { togglePreQuoteEditDialog } from "../../../../../app/slices/VerificationModuleSlice";

function CommandBar(){
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const verification = useAppSelector((state) => state.verification.verification);
    const isPreQuote = verification.verifyAttributes?.isPreQuote ?? false;
    const [saveVerification, status] = useSaveVerificationMutation();
    const [notify, setNotify] = useState(false)
    const profile = useMyProfileQuery();

    useEffect(()=>{setNotify(status.isSuccess)},[status.isSuccess]);

    const saveCase=()=>{
        const command = new VerificationSaveCommand(verification);
        saveVerification(command);
    }

    return <React.Fragment>
        <Stack direction='row' justifyContent='flex-end' gap={1} alignItems='center'>
            {isPreQuote && (
                <Tooltip title="Edit Pre-Quote">
                    <IconButton onClick={() => dispatch(togglePreQuoteEditDialog())} sx={{color: '#9C27B0', border: '1px solid #9C27B0', borderRadius: 1, height: '36.5px', width: '36.5px'}}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
            <Button variant='outlined' color="primary" onClick={()=> saveCase()}>Save</Button>
            <Button variant="outlined" color='success' onClick={()=>navigate(-1)}>Go Back</Button>
        </Stack>
        <Snackbar open={notify} onClose={()=>setNotify(false)} color='success' autoHideDuration={6000} message='Case successfully saved'/>
        <Snackbar open={status.isError}>
            <Alert color='error'>{'An error has occured: ' + JSON.stringify(status.error)}</Alert>
        </Snackbar>
    </React.Fragment>
}

export {CommandBar}